var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oilMap"},[_c('div',{staticClass:"echartsBox"},[_c('EchartsComp',{attrs:{"options":_vm.chart1_option,"dataObj":_vm.dataObj}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }